import {
    AssessmentDetails,
    UserRole,
} from '../multi-stage-assignment-report/store/multi-stage-assignment-report.model';
import { AssessmentReportingType } from './multi-stage-report-player.constants';

export const EVENT_NAMESPACE = {
    MSDA_REPORT_ASSIGNMENT_LISTING: 'MSDA_REPORT_ASSIGNMENT_LISTING_NS',
    ASSIGNMENT_LISTING_MSDA_REPORT: 'ASSIGNMENT_LISTING_MSDA_REPORT_NS',
    ASSESSMENT_MSDA_REPORT: 'ASSESSMENT_MSDA_REPORT_NS',
    MSDA_REPORT_SEARCH_VIEWER: 'MASTERY_SEARCH_NS',
    MSDA_REPORT_MASTERY_DEEP_LINK: 'MSDA_REPORT_MASTERY_DEEP_LINK_NS',
    MSDA_REPORT_MSDA_GROWTH_REPORT: 'MSDA_REPORT_MSDA_GROWTH_REPORT',
};

export interface MultiStageReportEventData {
    action: EventAction;
    payload?: EventPayload;
}

export enum EventAction {
    CLOSE = 'CLOSE',
    GET_USER_PROFILE = 'GET_USER_PROFILE',
    LOADCOMPLETE = 'LOADCOMPLETE', // For Event Message communication
    LOAD_COMPLETE = 'LOAD_COMPLETE', // For post message communication
    LOAD_NEXT_QUESTION = 'LOADNEXTQUESTION',
    LOAD_PREV_QUESTION = 'LOADPREVQUESTION',
    LOAD_QUESTION = 'LOAD_QUESTION',
    PENPAL_CONNECTION_CREATED = 'PENPAL_CONNECTION_CREATED',
    RESIZE_PAGE = 'RESIZE_PAGE',
    NAVIGATION = 'NAVIGATION',
    REQUEST_RBS_TOKEN = 'REQUEST_RBS_TOKEN',
    RBS_TOKEN = 'RBS_TOKEN',
    LOAD_SEARCH_VIEWER = 'LOADSEARCHVIEWER',
    ASSESSMENT_DETAILS = 'ASSESSMENT_DETAILS',
    PRINT_REPORT = 'PRINT_REPORT',
    CHANGE_SELECTED_REPORT_TYPE = 'CHANGE_SELECTED_REPORT_TYPE',
}

export const CelEvents = {
    celModalCloseEvent: 'celModalCloseEvent',
    celModalAcceptEvent: 'celModalAcceptEvent',
    celTextLinkClicked: 'celTextLinkClicked',
    celModalCancelEvent: 'celModalCancelEvent',
};

export interface CloseActionPayload {
    closeActionResponse: boolean | void;
}

export interface ClassMetricPayload {
    selectedReportType: AssessmentReportingType;
}

export interface PrintReportPayload {
    studentId: string;
}

export interface UserProfilePayload {
    userProfile: {
        role: string;
    };
}

export interface GetUserProfileEvent {
    action: EventAction;
    userProfile: {
        role: UserRole;
    };
}

export interface ResizePagePayload {
    resize_height: number;
}

export interface PopupMenuItem {
    id: string;
    label: string;
}

export interface NavigationPayload {
    url: string;
}

export interface LoadQuestionPayload {
    questionId: string;
    assessmentSessionId: string;
    sequence: any;
}

export interface LoadQuestionFromAssessmentsViewerPayload {
    assessmentSessionId: string;
    classId: string;
    questionPosition: number;
    programNames: string[];
}

export enum SearchViewerData {
    SEARCH_KEYWORD = 'searchKeyword',
    SELECTED_STANDARD = 'SELECTED_STANDARD',
    VIEW_RESOURCE_TITLE = 'VIEW_RESOURCE_TITLE',
    VIEW_RESOURCE_EXIT_URL = 'VIEW_RESOURCE_EXIT_URL',
    SELECTED_STANDARD_GUID = 'SELECTED_STANDARD_GUID',
    VIEW_RESOURCE_DESCRIPTION = 'VIEW_RESOURCE_DESCRIPTION',
}

export interface ResourceSearchMetaData {
    parentMfe: string;
    integratedAs: string;
    locale: string;
    standardTitle: string;
    standardDescription: string;
    backUrl: string;
    standards: {
        standardGuid: string[];
        stateStandards: string[];
    };
}

// Keep adding new interface for the payload as and when required
export type EventPayload =
    | CloseActionPayload
    | UserProfilePayload
    | ResizePagePayload
    | NavigationPayload
    | LoadQuestionPayload
    | LoadQuestionFromAssessmentsViewerPayload
    | AssessmentDetails
    | ClassMetricPayload
    | PrintReportPayload;
